import { ArtistFestivalType as ApiArtistFestivalType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../common';
import { ArtistFestivalType } from '../../types';

export const mapArtistFestivalType = (
  apiArtistFestival: ApiArtistFestivalType
): ArtistFestivalType => {
  return {
    festival: mapLinkableEntityType(apiArtistFestival.festival),
    date: apiArtistFestival.date,
  };
};
